import { setIntersectsObjects } from "./raycaster.js";
import { closeModal, openModal } from "./modals.js";
import { addObjectOnRoom, editObject } from "./addProductCard.js";
import { createObjToSave, loadJSON, saveJSON } from "./saveLoad.js";
import { openCorrectSideMenu } from "./dynamicLoader.js";
import { setCameraOnRoom } from "./setUpCamera.js";
import { applyRoomLighting } from "./scene.js";
import { saveConfigOnServ } from "../helpers/api.js";
import {
    initDropup,
    initPhoneMask,
    initReadyComplectsLinks,
    initToggleShowSizesListener,
    initTooltips,
} from "./initListeners.js";
import { resetRoomColors, resetRoomSizes } from "../helpers/resets.js";
import { hideAndRemoveInArr } from "./changeObjectParams/helpers/hideAndRemoveInArr.js";
import { hideAndRemoveAllActiveArrays } from "./changeObjectParams/helpers/hideAndRemoveAllActiveArrays.js";
import { resetCalculator, updateTotalBuildingPrice } from "./calculator.js";
import "./addShelfBlock.js";
import { closeModalLoader, openModalLoader } from "../helpers/openCloseModalLoader.js";
import { setVis } from "../helpers/setVis.js";
import { initCustomSelects } from "./customSelects.js";
import md5 from "crypto-js/md5";
import { getIsMobile } from "../helpers/getIsMobile.js";
import { crossCloserHandler } from "./crossCloserHandler.js";
import Tips from "./tips";
import { resetObjectParams } from "./resetObjectParams.js";
import { closeMenu } from "../helpers/closeMenu.js";
import { toggleDoorsHandler } from "./doorAnimationStore.js";

// Блокируем pointerdown для правой кнопки мыши глобально
if (!window._rightButtonBlockerAdded) {
    // Проверяем, добавлен ли уже обработчик
    document.addEventListener(
        "pointerdown",
        (e) => {
            if (e.target === document.querySelector("canvas")) return;
            if (e.button === 2) {
                e.stopImmediatePropagation();
                e.preventDefault();
            }
        },
        true,
    );
    window._rightButtonBlockerAdded = true; // Устанавливаем флаг, чтобы не добавлять обработчик повторно
}

let isRotating = false;
const rotationEvent = () => {
    if (!servObj.active || isRotating) return;

    isRotating = true;

    const onComplete = () => {
        isRotating = false;
    };

    if (servObj.active.name == "column") {
        servObj.building.rotateColumn(servObj.active);
        onComplete(); // Для column поворот мгновенный
    } else {
        // Для объектов с анимацией
        servObj.building.rotateObject(servObj.active, onComplete);
    }

    setIntersectsObjects([...servObj.building._all, ...servObj.building.walls, servObj.building.floor]);
    servObj.building.checkCollision();

    if (servObj.active.name == "column") {
        document.querySelector(".barrier_sizes .length_box input").value = servObj.building.getColumnSize(
            servObj.active,
        ).x;
        document.querySelector(".barrier_sizes .width_box input").value = servObj.building.getColumnSize(
            servObj.active,
        ).z;
    }

    servObj.guideLines.recalculateLinesPosition(servObj.active, servObj.guideLines.findNeighbours(servObj.active));
};

let isBusy = false;

const copyEvent = async () => {
    if (isBusy || !servObj.active) return;
    isBusy = true;

    try {
        let newColumn;

        if (servObj.active.name === "column") {
            newColumn = servObj.building.copyColumn(servObj.active);
        } else {
            newColumn = servObj.building.copyObject(servObj.active);
        }

        servObj.active = newColumn;
        setIntersectsObjects([...servObj.building._all, ...servObj.building.walls, servObj.building.floor]);
        servObj.building.columns.forEach((column) => {
            column.children[0].material.emissive.set(0x000000);
        });

        if (servObj.active.name === "column") {
            servObj.active.children[0].material.emissive.set(0xaaaaaa);
        }

        servObj.building.checkCollision();
        servObj.guideLines.recalculateLinesPosition(servObj.active, servObj.guideLines.findNeighbours(servObj.active));
        servObj.building.changeCamera(servObj.scene.activeCamera, servObj.scene.activeRenderer);
        updateTotalBuildingPrice();
    } finally {
        isBusy = false;
    }
};

// Валидация значения input
const validateTargetValue = (target) => {
    if (+target.value > +target.max) target.value = target.max;
    if (+target.value < +target.min) target.value = target.min;
    return target;
};

const buildingChangeSizeEvent = () => {
    const width = Number(validateTargetValue(document.querySelector(".room_sizes .length_box input")).value);
    const depth = Number(validateTargetValue(document.querySelector(".room_sizes .width_box input")).value);
    const height = Number(validateTargetValue(document.querySelector(".room_sizes .heigth_box input")).value);

    servObj.building.width = width;
    servObj.building.depth = depth;
    servObj.building.height = height;

    if (servObj.active) {
        document.querySelector(".barrier_sizes .length_box input").value = servObj.building.getColumnSize(
            servObj.active,
        ).x;
        document.querySelector(".barrier_sizes .width_box input").value = servObj.building.getColumnSize(
            servObj.active,
        ).z;
    }
    servObj.building.checkCollision();
    if (servObj.active)
        servObj.guideLines.recalculateLinesPosition(servObj.active, servObj.guideLines.findNeighbours(servObj.active));
};

const columnEvent = (e) => {
    if (e) {
        e.preventDefault();
    }
    const width = Number(validateTargetValue(document.querySelector(".barrier_sizes .length_box input")).value);
    const depth = Number(validateTargetValue(document.querySelector(".barrier_sizes .width_box input")).value);
    if (servObj.active && servObj.active.name == "column") {
        servObj.building.changeSizeColumn(servObj.active, width, depth);

        // aftercut
        document.querySelector(".barrier_sizes .length_box input").value = servObj.building.getColumnSize(
            servObj.active,
        ).x;
        document.querySelector(".barrier_sizes .width_box input").value = servObj.building.getColumnSize(
            servObj.active,
        ).z;
    } else {
        const newColumn = servObj.building.addColumn(width, depth);
        servObj.active = newColumn;
        document.querySelector(".barrier_sizes .length_box input").value = servObj.building.getColumnSize(newColumn).x;
        document.querySelector(".barrier_sizes .width_box input").value = servObj.building.getColumnSize(newColumn).z;
    }

    setIntersectsObjects([...servObj.building._all, ...servObj.building.walls, servObj.building.floor]);
    servObj.building.initBuildingDragControls(servObj.scene.activeCamera, servObj.renderer);
    servObj.building.checkCollision();
    servObj.guideLines.recalculateLinesPosition(servObj.active, servObj.guideLines.findNeighbours(servObj.active));
    servObj.guideLines.showLines();

    document.querySelector(".assist_btns").classList.remove("hide");
    document.getElementById("edit").classList.add("hide");
};
let hbBool = false;
// События клавиатуры
document.addEventListener("keydown", (e) => {
    const isOpenedModal = document.querySelector(".modal.show"); // Проверяем, есть ли открытое модальное окно
    const isFormRoomSizesFocused = document.querySelector("#room_sizes_form input:focus");
    const shouldHandleKey = !(servObj.isEditMode || servObj.isRedactorMode || isOpenedModal || isFormRoomSizesFocused); // Нужно ли (в текущий момент) обрабатывать нажатие клавиши

    if (e.code == "Enter" || e.code == "NumpadEnter") {
        if (isOpenedModal) {
            document.activeElement.blur();
            const event = new Event("pointerdown", {
                bubbles: true,
            });
            const button = isOpenedModal.querySelector(".modal_btn-confirm");
            button.dispatchEvent(event);
        } else {
            if (
                ((e.target.name == "room_sizes_length" && window.servObj.building.width != e.target.value) ||
                    (e.target.name == "room_sizes_width" && window.servObj.building.depth != e.target.value)) &&
                servObj.building._objects.length
            ) {
                openModal("change_room_modal");
            }
            if (e.target.name == "room_sizes_height") buildingChangeSizeEvent();
            if (e.target.name == "barrier_sizes_lenght" || e.target.name == "barrier_sizes_width") {
                columnEvent();
            }
        }
    }
    if (e.code == "KeyR" && shouldHandleKey) {
        rotationEvent();
    }
    if (e.code == "KeyC" && shouldHandleKey) {
        copyEvent();
    }
    if (e.code == "KeyE" && shouldHandleKey) {
        editObject();
    }
    if (e.code == "KeyH" && shouldHandleKey) {
        hbBool = !hbBool;
        servObj.activeHitbox.forEach((el) => setVis(el, hbBool));
    }
    if (e.code == "Delete" || e.code == "NumpadDecimal") {
        if (!shouldHandleKey) return;

        const active = document.activeElement;
        if (
            active &&
            ((active.tagName === "INPUT" &&
                (active.type === "text" || active.type === "number" || active.type === "color")) ||
                active.tagName === "TEXTAREA")
        ) {
            return;
        }

        const modal_title = document.querySelector("#delete_object_modal .modal-title");
        const isColumn = servObj.active && servObj.active.name === "column";
        modal_title.textContent = isColumn ? "Удалить препятствие?" : "Удалить объект?";

        openModal("delete_object_modal");
    }
    // if (e.code == "Space") {
    //     window.gui.show(window.gui._hidden);
    // }
    if (e.code == "Escape") {
        if (servObj.modals.isOpen && servObj.modals.id) {
            if (servObj.modals.id === "change_object_params_modal") {
                document.querySelector('input[name="edition"][value="general"]').checked = true;
            }
            closeModal(servObj.modals.id);
        }
    }
});

// WRAP BUTTONS

document.querySelector("#copy")?.addEventListener("pointerdown", copyEvent);

document.querySelector("#rotate")?.addEventListener("pointerdown", rotationEvent);
document.querySelector("#delete")?.addEventListener("pointerdown", () => {
    if (!servObj.active) return;
    if (servObj.active.name == "column") openModal("delete_object_modal", null, null, "Удалить препятствие?");
    if (servObj.active.name !== "column") openModal("delete_object_modal", null, null, "Удалить товар?");
});

document.querySelector("#delete_object_modal .modal_btn-confirm")?.addEventListener("pointerdown", () => {
    if (!servObj.active) return;

    if (servObj.active.name == "column") servObj.building.deleteColumn(servObj.active);
    if (servObj.active.name !== "column") servObj.building.deleteObject(servObj.active);

    setIntersectsObjects([...servObj.building._all, ...servObj.building.walls, servObj.building.floor]);
    servObj.building.checkCollision();
    servObj.guideLines.hideLines();
    // servObj.allTableInRoom = servObj.allTableInRoom.filter((i) => i.name !== servObj.active.name);
    document.querySelector(".assist_btns").classList.add("hide");
    servObj.building.initBuildingDragControls(servObj.scene.activeCamera, servObj.renderer);
    servObj.active = null;
    updateTotalBuildingPrice();
});

// Добавление объекта в помещение
document.getElementById("add_in_room_btn")?.addEventListener("pointerdown", addObjectOnRoom);

// Редактирование выбранного объекта
document.getElementById("edit")?.addEventListener("pointerdown", editObject);

const menuToggler = document.querySelector(".cross_closer__menu");
const menuTogglerMobile = document.querySelector(".open-params-mobile");

if (!window._crossCloserMenuListenerAdded) {
    document.addEventListener("click", (e) => {
        if (e.target.classList.contains("cross_closer__menu")) {
            crossCloserHandler(menuToggler);
        }
    });
    window._crossCloserMenuListenerAdded = true;
}

menuTogglerMobile.addEventListener("click", () => crossCloserHandler(menuToggler));

if (getIsMobile()) crossCloserHandler(menuToggler);

// Ищем только модалки с "особой" логикой
document.querySelectorAll("[data-use-global-confirm]").forEach((modal) => {
    const modalName = modal.getAttribute("id"); // или другой атрибут, если id не уникален

    // Кнопка "подтвердить"
    modal.querySelector(".modal_btn-confirm")?.addEventListener("pointerdown", () => {
        if (typeof servObj.modals.onConfirm === "function") {
            servObj.modals.onConfirm(modalName);
        }
        closeModal(modalName);
    });

    // Кнопка "отмена"
    modal.querySelector(".modal_btn-cancel")?.addEventListener("pointerdown", () => {
        if (typeof servObj.modals.onCancel === "function") {
            servObj.modals.onCancel(modalName);
        }
        closeModal(modalName);
    });
});

let state = false;
document.getElementById("show_hitbox").addEventListener("click", () => {
    state = !state;
    servObj.scene.traverse((object) => {
        if (object.parent && object.parent.visible && object.name.includes("hitbox")) {
            object.visible = state;
        }
    });
});

document.getElementById("load_project").addEventListener("pointerdown", () => {
    openModal("download_project");
});

document.getElementById("save_project").addEventListener("pointerdown", () => {
    openModal("save_project_modal");
});

let loadedJSON = null;
const downloadBtn = document.getElementById("spec_download_btn");
document.getElementById("spec_file_download_input").addEventListener("change", async (e) => {
    const file = e.target.files[0];
    const fileNameDisplay = document.getElementById("file-name-display");

    if (!file) {
        fileNameDisplay.textContent = "Файл не выбран";
        downloadBtn.classList.add("disable");
        loadedJSON = null;
        return;
    }

    fileNameDisplay.textContent = file.name;

    try {
        const text = await file.text();
        loadedJSON = JSON.parse(text);
        downloadBtn.classList.remove("disable");
    } catch (err) {
        fileNameDisplay.textContent = "Ошибка: некорректный JSON";
        downloadBtn.classList.add("disable");
        loadedJSON = null;
        console.error(err);
    }
});

document.getElementById("checkout_file_upload_input").addEventListener("change", async (e) => {
    const input = e.target;
    const file = input.files[0];
    const fileNameDisplay = document.querySelector(".file-name-display");
    const fileUploadWrap = document.querySelector("#checkout-form .custom-file-upload");

    fileUploadWrap.classList.remove("error");

    if (!file) {
        fileNameDisplay.textContent = "Файл не выбран";
        return;
    }

    // Получаем допустимые расширения из accept и убираем точки
    const allowedExtensions = input.accept.split(",").map((ext) => ext.trim().replace(".", "").toLowerCase());
    const fileExtension = file.name.split(".").pop().toLowerCase();

    const error = (err = null) => {
        fileNameDisplay.textContent = "Ошибка: некорректный файл";
        fileUploadWrap.classList.add("error");
        err && console.error(err);
    };

    // Проверка расширения
    if (!allowedExtensions.includes(fileExtension)) {
        error("Недопустимое расширение");
        return;
    }

    // Проверка размера (максимум 1 МБ)
    const maxSize = 1024 * 1024; // 1 MB
    if (file.size > maxSize) {
        fileNameDisplay.textContent = "Ошибка: файл больше 1 МБ";
        fileUploadWrap.classList.add("error");
        return;
    }

    fileNameDisplay.textContent = file.name;

    try {
        // console.log("Файл загружен");
        // здесь можно дальше работать с файлом
    } catch (err) {
        error(err);
    }
});

downloadBtn.addEventListener("pointerdown", async () => {
    if (!downloadBtn.classList.contains("disable") && loadedJSON) {
        const modalTextContent = "Идёт загрузка <br/> выбранного файла";
        openModalLoader(modalTextContent);
        await loadJSON(loadedJSON);
        closeModalLoader();
    }
});

document.getElementById("get_pdf_btn").addEventListener("pointerdown", async () => {
    const iframe = document.getElementById("iframe");
    await iframe.contentWindow.postMessage(
        {
            type: "save-pdf",
        },
        "*",
    );
});

initTooltips();

const saveProjectInput = document.getElementById("save_file_name");
const saveProjectBtn = document.getElementById("save_project_btn");

saveProjectInput.addEventListener("input", (e) => {
    const hasValue = e.target.value.length > 0;

    saveProjectBtn.classList.toggle("disable", !hasValue);
});

saveProjectBtn.addEventListener("pointerdown", async () => {
    const data = await createObjToSave();
    const fileName = saveProjectInput.value;
    saveJSON(data, fileName);
});

document.getElementById("new_project").addEventListener("pointerdown", () => {
    openModal(
        // ID модалки
        "new_project_modal",

        // Действие на кнопку "Да"
        async () => {
            if (servObj.isRedactorMode) {
                await resetObjectParams();
            } else {
                hideAndRemoveAllActiveArrays();
                hideAndRemoveInArr(servObj.building._columns);
                hideAndRemoveInArr(servObj.building._all);
                servObj.building._objects = [];
                servObj.active = null;
                servObj.guideLines.hideLines();
                resetRoomSizes();
                resetRoomColors();

                openCorrectSideMenu("main_btns");
                servObj.isEditMode = false;
                servObj.isRedactorMode = false;
                document.getElementById("add_in_room_btn").parentNode.classList.add("hide");
                document.querySelector(".animate-doors_btn_wrap").classList.add("hide");
                document.querySelector(".assist_btns").classList.add("hide");
                setCameraOnRoom();
                applyRoomLighting();
                document.querySelector(".view2d3d").classList.remove("hide");
                document.querySelector(".sizes").classList.remove("hide");
                resetCalculator();
                updateTotalBuildingPrice();
            }
        },

        // Действие на кнопку "Нет"
        () => {},

        // Заголовок модалки
        "Сбросить настройки?",
    );
});

initDropup();

initReadyComplectsLinks();

initCustomSelects();

const sharedLinkInput = document.getElementById("share_project_link");

function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
            .writeText(text)
            .then(() => {})
            .catch((err) => {
                console.error("Ошибка копирования:", err);
            });
    } else {
        console.warn("Clipboard API недоступен");
        // Альтернатива или фолбэк:
        fallbackCopyText(text);
    }
}

function fallbackCopyText(text) {
    const tempInput = document.createElement("input");
    tempInput.style.position = "absolute";
    tempInput.style.left = "-9999px";
    tempInput.value = text;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);
}

const copyLinkBtns = document.querySelectorAll(".copy_link_btn");
copyLinkBtns.forEach((btn) => {
    btn.addEventListener("pointerdown", (e) => {
        e.preventDefault();
        copyText(sharedLinkInput.value);
    });
});

// document.getElementById("share_project").addEventListener("pointerdown", () => {
//     openModal("share_project_modal");
//     startPlaceholderAnimation();
//     // Пример: через 5 секунд появляется ссылка
//     setTimeout(() => {
//         sharedLinkInput.value = "https://esd-mebel.ru/?filename=asdfghjAtB";
//         stopPlaceholderAnimation();
//     }, 5000);
// });

let dots = 0;
let intervalId = null;

// Функция запуска анимации "Ссылка генерируется..."
function startPlaceholderAnimation() {
    copyLinkBtns.forEach((btn) => {
        btn.classList.add("disable"); // Блокируем кнопки копирования
    });
    intervalId = setInterval(() => {
        dots = (dots + 1) % 4; // 0,1,2,3
        sharedLinkInput.placeholder = "Ссылка генерируется" + ".".repeat(dots);
    }, 200); // каждые 200 мс обновляется
}

// Функция остановки анимации (когда value появилось)
function stopPlaceholderAnimation() {
    copyLinkBtns.forEach((btn) => {
        btn.classList.remove("disable"); // Разблокируем кнопки копирования
    });
    clearInterval(intervalId);
}

const shareProjectModal = document.getElementById("share_project_modal");

const target = shareProjectModal;

const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
        if (mutation.type === "attributes" && mutation.attributeName === "class") {
            const currentClassList = mutation.target.classList;

            if (!currentClassList.contains("show")) {
                // Класс "show" исчез — выполняем действие
                stopPlaceholderAnimation(); // Останавливаем анимацию
                setTimeout(() => {
                    sharedLinkInput.value = ""; // Очищаем значение input
                }, 300); // С задержкой, чтобы дать время на скрытие модального окна
            }
        }
    }
});

// Настраиваем наблюдение за атрибутами
observer.observe(target, { attributes: true });

document.getElementById("share_project").addEventListener("pointerdown", async () => {
    openModal("share_project_modal");
    startPlaceholderAnimation();

    const data = await createObjToSave();
    const dataStr = JSON.stringify(data);
    const currentHash = md5(dataStr).toString();

    // если проект не изменился → используем кэш
    if (servObj.cache.lastSavedHash === currentHash && servObj.cache.lastGeneratedLink) {
        sharedLinkInput.value = servObj.cache.lastGeneratedLink;
        stopPlaceholderAnimation();
        return;
    }

    // иначе сохраняем на сервер
    function removeJsonSuffix(str) {
        return str.replace(/\.json$/, "");
    }

    saveConfigOnServ(data).then((result) => {
        if (result && result.success) {
            const URL = window.origin;
            const currentPath = window.location.pathname.split("/").slice(0, -1).join("/");
            const link = `${URL}${currentPath}/?filename=${removeJsonSuffix(result.filename)}`;

            sharedLinkInput.value = link;

            // обновляем кэш
            servObj.cache.lastSavedHash = currentHash;
            servObj.cache.lastGeneratedLink = link;

            stopPlaceholderAnimation();
        }
    });
});

initToggleShowSizesListener();

const room = [
    { link: "./komplekts/room/komplekt_1.json", name: "Комплект 1" },
    { link: "./komplekts/room/komplekt_2.json", name: "Комплект 2" },
    { link: "./komplekts/room/komplekt_3.json", name: "Комплект 3" },
    { link: "./komplekts/room/komplekt_4.json", name: "Комплект 4" },
    { link: "./komplekts/room/komplekt_5.json", name: "Комплект 5" },
];

initReadyComplectsLinks(room);

document.getElementById("load_complete_spec").addEventListener("pointerdown", async function () {
    const path = this.dataset.path;

    if (!path) return;

    const modalTextContent = "Идёт загрузка выбранной <br/> комплектации";
    openModalLoader(modalTextContent);

    await new Promise((res) =>
        setTimeout(() => {
            res();
        }, 100),
    );

    try {
        const response = await fetch(path);
        if (!response.ok) {
            throw new Error(`Ошибка загрузки файла: ${path}`);
        }

        const contentType = response.headers.get("content-type");
        if (!contentType || !contentType.includes("application/json")) {
            const textContentModalLoader = document.querySelector("#loader_modal .modal-title");
            textContentModalLoader.textContent = "Ошибка загрузки выбранной комплектации.";
            throw new Error(`Файл по пути ${path} не является валидным JSON`);
        }

        const json = await response.json();
        await loadJSON(json); // ⬅️ передаём загруженный JSON

        const dropupElements = document.querySelectorAll(".dropup");
        dropupElements.forEach((dropup) => dropup.classList.remove("active"));
        closeModalLoader();
    } catch (error) {
        console.error("Ошибка при загрузке", error);
        // Здесь вы можете добавить уведомление пользователю или логирование ошибки
        setTimeout(() => {
            closeModalLoader();
        }, 5000);
    }
});

// Добавляем маски для всех инпутов с type="tel"
initPhoneMask();

const showTipsBtn = document.querySelector("#show-tips");
showTipsBtn.addEventListener("click", () => {
    const sideMenuScrollContainer = document.querySelector("#form-object-params");
    if (sideMenuScrollContainer instanceof HTMLElement) {
        sideMenuScrollContainer.scrollTo(0, 0);
    }

    const pageName = servObj.isRedactorMode ? "product" : "main";
    Tips.show(pageName);
});

const backgroundBlackInMobile = document.querySelector(".menu-background");
backgroundBlackInMobile.addEventListener("click", closeMenu);

const doorAnimateBtn = document.getElementById("animate-doors");
doorAnimateBtn.addEventListener("click", toggleDoorsHandler);

// ------------- ДЛЯ ДЕБАГА ПОЯВЛЕНИЯ/СКРЫТИЯ КЛАССА У УКАЗАННОГО ЭЛЕМЕНТА (ПО СЕЛЕКТОРУ) --------------- //
// ------------- КОГДА ЗАКОНЧИЛ С ДЕБАГОМ, КОММЕНТИРУЙ/УДАЛЯЙ ВЫПОЛНЕНИЕ ЭТОЙ ФУНКЦИИ! ------------------ //
// function initDebugToggleClass(targetSelector) {
//     const observedElements = new WeakSet();

//     const observeClassChanges = (element) => {
//         if (observedElements.has(element)) return;
//         observedElements.add(element);

//         const observer = new MutationObserver((mutationsList) => {
//             for (const mutation of mutationsList) {
//                 if (mutation.attributeName === "class") {
//                     console.log("🟡 Классы изменились у:", element);
//                     console.log("➡️ Новые классы:", element.className);
//                     console.trace("🔍 Stack trace изменения class");
//                 }
//             }
//         });

//         observer.observe(element, { attributes: true });
//     };

//     // Наблюдение за существующими
//     document.querySelectorAll(targetSelector).forEach(observeClassChanges);

//     // Наблюдение за новыми
//     const domObserver = new MutationObserver((mutationsList) => {
//         for (const mutation of mutationsList) {
//             for (const node of mutation.addedNodes) {
//                 if (!(node instanceof HTMLElement)) continue;

//                 if (node.matches?.(targetSelector)) {
//                     observeClassChanges(node);
//                 }

//                 node.querySelectorAll?.(targetSelector)?.forEach?.(observeClassChanges);
//             }
//         }
//     });

//     domObserver.observe(document.body, { childList: true, subtree: true });
// }

// Использование
// initDebugToggleClass(".btn_add.add_metall");
